module.exports = __webpack_public_path__ + "static/9a6c1356.oldUI_out_modal_img.png";